/**
 * Galat yang dilempar `publicFetch`, membawa status HTTP dan body apa adanya.
 *
 * Body sengaja `unknown`: sebagian jalur memulangkan envelope kegagalan kontrak, sebagian
 * lagi teks mentah (rute non-JSON). Menyatakannya bertipe envelope akan membuat pemanggil
 * mengakses `.message` pada string tanpa peringatan kompilator.
 */
export class ApiError extends Error {
  // Field dideklarasikan lalu diisi di badan konstruktor, BUKAN lewat parameter property
  // (`constructor(public readonly status: number)`). Template memakai
  // `erasableSyntaxOnly`, dan parameter property adalah sintaks TypeScript yang
  // memancarkan kode — ia gagal di sana (TS1294), bukan sekadar tidak disukai.
  readonly status: number;
  readonly body: unknown;

  constructor(status: number, body: unknown) {
    super(pesanDari(status, body));
    this.name = "ApiError";
    this.status = status;
    this.body = body;
  }
}

function pesanDari(status: number, body: unknown): string {
  if (typeof body === "string" && body.trim() !== "") return `HTTP ${status}: ${body}`;
  if (typeof body === "object" && body !== null) {
    const record = body as Record<string, unknown>;
    const message = record.message ?? (record.error as Record<string, unknown> | undefined)?.message;
    if (typeof message === "string") return `HTTP ${status}: ${message}`;
  }
  return `HTTP ${status}`;
}
